import {
  recurrenceFrequencies,
  recurrenceWeekdays,
  updateRecurrenceFormField,
} from '../../lib/recurrence';
import { inputClassName } from './ScreenPrimitives';

function RecurrenceEditor({
  value,
  onChange,
  idPrefix,
  requireDateCopy = 'Choose a date before enabling recurrence.',
}) {
  const updateField = (field, nextValue) => {
    onChange(updateRecurrenceFormField(value, field, nextValue));
  };

  return (
    <div className="space-y-4 rounded-2xl border border-app-border/70 bg-app-surface-alt/70 p-4">
      <label className="flex items-center gap-3 text-sm font-medium text-app-ink">
        <input
          type="checkbox"
          checked={Boolean(value?.enabled)}
          onChange={(event) => updateField('enabled', event.target.checked)}
        />
        <span>Repeat this item</span>
      </label>

      {value?.enabled ? (
        <div className="space-y-4">
          <p className="m-0 text-sm leading-6 text-app-muted">{requireDateCopy}</p>

          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-app-ink" htmlFor={`${idPrefix}-frequency`}>
                Frequency
              </label>
              <select
                id={`${idPrefix}-frequency`}
                value={value.frequency}
                onChange={(event) => updateField('frequency', event.target.value)}
                className={inputClassName}
              >
                {recurrenceFrequencies.map((frequency) => (
                  <option key={frequency} value={frequency}>
                    {frequency}
                  </option>
                ))}
              </select>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-app-ink" htmlFor={`${idPrefix}-interval`}>
                Interval
              </label>
              <input
                id={`${idPrefix}-interval`}
                type="number"
                min="1"
                value={value.interval}
                onChange={(event) => updateField('interval', event.target.value)}
                className={inputClassName}
              />
            </div>
          </div>

          {value.frequency === 'weekly' ? (
            <div className="space-y-2">
              <p className="m-0 text-sm font-semibold text-app-ink">Days of week</p>
              <div className="flex flex-wrap gap-2">
                {recurrenceWeekdays.map((day) => {
                  const active = value.daysOfWeek?.includes(day.value);
                  return (
                    <button
                      key={day.value}
                      type="button"
                      className={
                        active
                          ? 'rounded-xl border border-app-accent/40 bg-app-accent px-3 py-2 text-sm font-semibold text-white'
                          : 'rounded-xl border border-app-border bg-app-surface px-3 py-2 text-sm font-medium text-app-ink transition hover:bg-app-surface-alt'
                      }
                      onClick={() => updateField('daysOfWeek', day.value)}
                    >
                      {day.label}
                    </button>
                  );
                })}
              </div>
            </div>
          ) : null}

          {value.frequency === 'monthly' || value.frequency === 'yearly' ? (
            <div className="grid gap-4 sm:grid-cols-2">
              <div className="space-y-2">
                <label className="text-sm font-semibold text-app-ink" htmlFor={`${idPrefix}-day`}>
                  Day of month
                </label>
                <input
                  id={`${idPrefix}-day`}
                  type="number"
                  min="1"
                  max="31"
                  value={value.dayOfMonth}
                  onChange={(event) => updateField('dayOfMonth', event.target.value)}
                  placeholder="Same day"
                  className={inputClassName}
                />
              </div>

              {value.frequency === 'yearly' ? (
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-app-ink" htmlFor={`${idPrefix}-month`}>
                    Month
                  </label>
                  <input
                    id={`${idPrefix}-month`}
                    type="number"
                    min="1"
                    max="12"
                    value={value.monthOfYear}
                    onChange={(event) => updateField('monthOfYear', event.target.value)}
                    placeholder="Same month"
                    className={inputClassName}
                  />
                </div>
              ) : null}
            </div>
          ) : null}

          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-app-ink" htmlFor={`${idPrefix}-ends-at`}>
                Ends at
              </label>
              <input
                id={`${idPrefix}-ends-at`}
                type="date"
                value={value.endsAt}
                onChange={(event) => updateField('endsAt', event.target.value)}
                className={inputClassName}
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-app-ink" htmlFor={`${idPrefix}-count`}>
                Occurrences
              </label>
              <input
                id={`${idPrefix}-count`}
                type="number"
                min="1"
                value={value.occurrenceCount}
                onChange={(event) => updateField('occurrenceCount', event.target.value)}
                placeholder="No limit"
                className={inputClassName}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default RecurrenceEditor;
